import React, { useEffect, useState } from 'react'
import TblRow from '../widgets/TblRow';
import TblCell from '../widgets/TblCell';
import InviTrackSum from './InviTrackSum';
import Tbl from '../widgets/Tbl';
import TblHdr from '../widgets/TblHdr';
import useDisplayTime from '../../hooks/useDisplayTime';
import useWebSocketCaller from '../../hooks/useWebSocketCaller';
import useQueueHandler from '../../hooks/useQueueHandler';
import { useWebSocketContext } from '../../providers/WebSocketContextProvider';
import { useOperatorContext } from '../login/OperatorContextProvider';
import { useOrganListenerContext } from '../../providers/OrganListenerContextProvider';
import './TeamControl.css'
import './InviTrack.css'

export default function MyInvites({popInviteSetter, clearModified}) {
  const {operator}                                  = useOperatorContext();
  const {isWebSocketReady, webSocketState}          = useWebSocketContext();
  const {myInvites}                                 = useOrganListenerContext();
  const {sendMessage}                               = useWebSocketCaller();
  const {queueData:myNotify}                        = useQueueHandler('invite');   
  const {displayTimestamp}                          = useDisplayTime();
  const [sortedInvites, setSortedInvites]           = useState(myInvites ? myInvites : []);
  const [myMessage, setMyMessage]                   = useState(null);

  //------  Effect  ------
  //
  useEffect(()=>{
    if (isWebSocketReady()) {
      sendMessage('get-my-invites', ({
        teamId: operator.selectedTeamId,
        username: operator.username,
        accountId: operator.accountId
      }));
    }
  }, [webSocketState, sendMessage, isWebSocketReady, operator?.username, operator?.accountId, operator?.selectedTeamId]);


  //------  Effect  ------
  //
  useEffect(()=>{
    if (myInvites) {
      setSortedInvites([...myInvites].sort((a,b) => b.whenModified - a.whenModified));
    }
  },[myInvites]);
  
  
  //------  Effect  ------
  //
  useEffect(()=>{
    if (myNotify) {
      setMyMessage(myNotify);
    }
  }, [myNotify]);


  //------  Invite Clicked  ------
  //
  const handleInviteClicked = (invData) => {    
    popInviteSetter({...invData});
    clearModified();
  }


  //------   RENDER   ------//
  
  //------  Rows  ------
  const rows = sortedInvites.map((inv, index) =>  {
    if (inv.lifecycleState) {
      const state = inv.lifecycleState.toLowerCase();
      return (
      <TblRow key={index} onClick={() => handleInviteClicked(inv)}> 
        <TblCell title={inv.toFirstName} />
        <TblCell title={inv.toUsername} />
        <TblCell title={inv.toEmail} isWider={true}/>
        <TblCell title={displayTimestamp(inv.whenModified)}/>
        <TblCell title={displayTimestamp(inv.expiration)} />
        <TblCell title={inv.lifecycleState} state={state}/>
      </TblRow>);
    }
    else {
      return (
        <div>No Invites</div>
      )
    }
  });


  //------  MyMsg Comp  ------
  const myMsgComp = myMessage?.title ? <div className='myMessage'>
                        <div className='myMessageTitle'>{myMessage?.title}</div>
                        <div className='fromto'>
                          <div className='myMessageName'>From {myMessage?.from} ⟶ 🛩 ⟶ </div>
                          <div className='myMessageName'>To {myMessage?.to}</div>
                        </div>
                     </div> : '';
  
  
  return (
    <div className='teamInvites'>
      <div className='teamInviteHeader'>
        <div className='teamInviteHeaderTitle'>
          My Invitations
        </div>
        <InviTrackSum total={sortedInvites.length}/>        
      </div>
      <div className='invTblWrapper'>
        <Tbl>
          <TblHdr cols={['Name', 'Username', 'Email', 'Sent', 'Expiration', 'Status']} key={'team-invites-tbl-header'}/>
          {rows}
        </Tbl>        
        {myMsgComp}
      </div>
    </div>
  )
}
